import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

const CELL_WIDTH = "calc(100% / 7)";

export default makeStyles((theme: MuiTheme) => ({
  container: {
    padding: 24,
    flex: "auto",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      padding: 0
    }
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    paddingBottom: 24,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      justifyContent: "space-between",
      padding: 16
    }
  },
  headerTitle: {
    fontSize: 18,
    textTransform: "capitalize"
  },
  controls: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      flexDirection: "row-reverse"
    },
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      position: "absolute",
      left: 0
    }
  },
  control: {
    width: 24,
    height: 24
  },
  controlIcon: {
    color: theme.palette.text.primary
  },
  controlLabel: {
    color: theme.palette.text.primary,
    lineHeight: "normal",
    marginLeft: 16,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      marginLeft: 0,
      marginRight: 16
    }
  },
  dayNames: {
    display: "flex",
    flexWrap: "nowrap",
    width: "100%",
    paddingBottom: 4
  },
  dayName: {
    display: "flex",
    justifyContent: "center",
    width: CELL_WIDTH,
    color: theme.palette.text.hint,
    fontSize: 11,
    textTransform: "uppercase"
  },
  calendarWrapper: {
    flex: "auto",
    display: "flex",
    position: "relative"
  },
  calendar: {
    flex: "auto",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    borderStyle: "solid",
    borderColor: theme.palette.primary.light,
    borderWidth: "1px 0 0 1px"
  },
  dateButton: {
    position: "relative",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    width: CELL_WIDTH,
    minWidth: CELL_WIDTH,
    padding: "6px 0",
    borderStyle: "solid",
    borderColor: theme.palette.primary.light,
    borderWidth: "0 1px 1px 0",
    borderRadius: 0,
    transition: "background-color 166ms linear",
    textTransform: "none",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "rgba(97, 198, 158, 0.05)"
    }
  },
  blackout: {
    backgroundColor: "#e5e5e5",
    "&:hover": {
      backgroundColor: "#e5e5e5"
    }
  },
  dateButtonActive: {
    backgroundColor: "rgba(97, 198, 158, 0.15)",
    transition: "background-color 166ms linear",
    "&:hover": {
      backgroundColor: "rgba(97, 198, 158, 0.15)"
    }
  },
  pastDateBox: {
    "&:hover": {
      cursor: "default",
      backgroundColor: theme.palette.common.white
    }
  },
  date: {
    fontSize: 11,
    color: "#333333",
    lineHeight: "normal",
    minWidth: 20,
    padding: "0 5px",
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  pastDate: {
    color: theme.palette.text.secondary
  },
  today: {
    border: "1px solid black",
    borderRadius: 2
  },
  disabledMarker: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.secondary,
    fontSize: 11,
    border: "1px solid #7f7f7f",
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    width: 60,
    height: 20,
    top: "calc(50% - 10px)",
    left: "calc(50% - 30px)",
    lineHeight: "normal",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 9,
      width: 50,
      left: "calc(50% - 25px)"
    }
  },
  disabledMarkerOutlined: {
    borderColor: "#6C0808",
    color: "#6C0808",
    borderStyle: "dashed",
    borderRadius: 10
  }
}));
